// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  MdClearAll,
  MdSearch,
} from 'react-icons/lib/md';
import InfiniteScroll from 'react-infinite-scroller';
import i18n from 'i18n-js';

import type { NOTIFICATION_TYPE } from '../../types/notifications';
import { FullLoader } from '../Loader';
import PopupHeader from '../PopupHeader';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
// import PopupHeaderTitleContainer from '../PopupHeaderTitleContainer';
import SimplePlaceholder from '../SimplePlaceholder';
import PopupHeaderRightGroup from '../PopupHeaderRightGroup';
import PopupContent from '../PopupContent';
import PopupHeaderTitle from '../PopupHeaderTitle';
import NotificationElement from '../NotificationElement';
import Button from '../Button';
import Input from '../Input';
import PlaceholderView from '../PlaceholderViews';
import PlaceholderImage from '../../../assets/images/notificationsph.png';

import * as notificationActions from '../../actions/notifications';
import * as selectors from '../../reducers';

import styles from './notificationsListPopover.css';
import { NoResults, Loading } from '../CommonTexts';


type NotificationsPropTypes = {
  hasMore: boolean,
  changeScreen: Function,
  fetchNotifications: Function,
  bulkUpdateNotifications: Function,
  notifications: Array<NOTIFICATION_TYPE>,
  isLoading?: boolean,
  changeFilters: Function,
};

class NotificationsListPopover extends React.Component<NotificationsPropTypes> {
  _handleLoadMore(page) {
    const { fetchNotifications } = this.props;
    fetchNotifications(page);
  }

  render() {
    const {
      hasMore = false,
      changeScreen,
      notifications = [],
      bulkUpdateNotifications,
      isLoading = false,
      changeFilters,
    } = this.props;

    return (
      <Fragment>
        <PopupHeader size="small" isBorderless>
          <PopupHeaderLeftGroup>
            <PopupHeaderTitle title={i18n.t('common.notifications')} size="medium" />
          </PopupHeaderLeftGroup>
          <PopupHeaderRightGroup padding="verticalCenter">
            <Button
              size="small"
              title={i18n.t('buttons.dismissAll')}
              Icon={MdClearAll}
              iconPosition="left"
              tint="transparent"
              onClick={bulkUpdateNotifications}
            />
            <Button
              size="medium"
              title={i18n.t('buttons.send')}
              iconPosition="left"
              onClick={changeScreen}
            />
          </PopupHeaderRightGroup>
        </PopupHeader>
        <PopupContent size="medium" className={styles.popupContent} isContrasted>
          <Input
            placeholder={i18n.t('common.search')}
            size="medium"
            Icon={MdSearch}
            iconPosition="right"
            onChange={
              ({ target }) => changeFilters('title', target.value)
            }
          />
          <InfiniteScroll
            pageStart={1}
            loadMore={this._handleLoadMore.bind(this)}
            hasMore={hasMore}
            loader={
              <FullLoader
                key={0}
                tint="mediumGray"
                title={Loading(i18n.t('common.notifications'))}
              />
            }
            useWindow={false}
          >
            {
              isLoading
              && (
                <div className={styles.loader}>
                  <FullLoader
                    title={Loading(i18n.t('common.notifications'))}
                    key={-1}
                    tint="mediumGray"
                  />
                </div>
              )
            }
            {
              !isLoading
              && notifications.length === 0
              && <PlaceholderView
                    size="small"
                    image={PlaceholderImage}
                    title={NoResults(i18n.t('common.notifications').toLowerCase())}/>
            }
            {
              notifications.length > 0
              && notifications.map(notification => (
                <NotificationElement
                  key={notification.id}
                  {...notification}
                  date={notification.created_at}
                  notificationType={notification.notification_type}
                  isRead={notification.is_read}
                />
              ))
            }
          </InfiniteScroll>
        </PopupContent>
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    hasMore: selectors.hasMoreNotifications(state),
    notifications: selectors.getNotifications(state),
    order: selectors.getNotificationOrder(state),
    isLoading: selectors.areNotificationsFetching(state),
  }),
  dispatch => ({
    bulkUpdateNotifications(order) {
      dispatch(notificationActions.bulkUpdateNotifications(order));
    },
    changeScreen() {
      dispatch(notificationActions.changePopupScreen(2));
    },

    fetchNotifications(page) {
      dispatch(notificationActions.startFetchingNotifications(page));
    },
    changeFilters(key: string, filter: string) {
      dispatch(notificationActions.changeNotificationFilters(key, filter));
      dispatch(notificationActions.startFetchingNotifications(1));
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    bulkUpdateNotifications() {
      dispatchProps.bulkUpdateNotifications(stateProps.order);
    },
  }),
)(NotificationsListPopover);



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationsListPopover/index.jsx